export const capitalize = s => {
  if (typeof s !== "string") {
    return "";
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function getHslFromHex(hex) {
  // Convert hex to RGB first
  let r = 0;
  let g = 0;
  let b = 0;
  if (hex.length === 4) {
    r = `0x${hex[1]}${hex[1]}`;
    g = `0x${hex[2]}${hex[2]}`;
    b = `0x${hex[3]}${hex[3]}`;
  }
  else if (hex.length === 7) {
    r = `0x${hex[1]}${hex[2]}`;
    g = `0x${hex[3]}${hex[4]}`;
    b = `0x${hex[5]}${hex[6]}`;
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;

  const cmin = Math.min(r, g, b);
  const cmax = Math.max(r, g, b);
  const delta = cmax - cmin;
  let h;
  let s;
  let l;

  if (delta === 0) {
    h = 0;
  }
  else if (cmax === r) {
    h = ((g - b) / delta) % 6;
  }
  else if (cmax === g) {
    h = (b - r) / delta + 2;
  }
  else {
    h = (r - g) / delta + 4;
  }

  h = Math.round(h * 60);

  if (h < 0) {
    h += 360;
  }

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return { h, s, l };
}

export function generateFakeDates(num) {
  const fakeDates = [];
  for (let i = 0; i < num; i++) {
    const minDate = i !== 0 ? fakeDates[i - 1] : new Date();
    let maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 15);

    fakeDates.push(
      new Date(minDate.getTime() + Math.random() * (maxDate.getTime() - minDate.getTime()))
    )
  }

  return fakeDates;
}

export function getRandomImageBackgroundStyle(placeholderImages) {
  /** @var imagePlaceholderUrl string */
  let url = imagePlaceholderUrl
  if (placeholderImages && placeholderImages.length > 0) {
    if (placeholderImages.length === 1) {
      url = placeholderImages[0].url;
    } else {
      url = placeholderImages[Math.floor(Math.random() * placeholderImages.length)].url;
    }
  }

  return { backgroundImage: `url('${url}')` };
};
